import type { UpdateEvents } from "../../common/types.ts";
import type { MpLeague, MpSession } from "../../common/multiplayerConfig.ts";
import {
	getSession,
	myLeagues,
	unsubscribeLobby,
} from "../multiplayer/index.ts";

const updateMultiplayer = async (
	inputs: unknown,
	updateEvents: UpdateEvents,
) => {
	if (
		updateEvents.includes("firstRun") ||
		updateEvents.includes("multiplayer")
	) {
		// Navigated away from any lobby page
		await unsubscribeLobby();

		let session: MpSession | undefined;
		let leagues: MpLeague[] = [];
		// Named mpError rather than errorMessage because viewManager replaces
		// the whole page with a generic error view when a returned object has
		// an errorMessage key, even an undefined one.
		let mpError: string | undefined;

		try {
			session = await getSession();
			if (session) {
				leagues = await myLeagues();
			}
		} catch (error) {
			mpError = error.message;
		}

		return {
			session,
			leagues,
			mpError,
		};
	}
};

export default updateMultiplayer;
